import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 16px;

  /* S - Tablet */
  @media (min-width: 600px) {
    padding: 0 24px;
  }

  /* M - Small laptop */
  @media (min-width: 1280px) {
    padding: 0 24px;
  }

  /* L - Default laptop */
  @media (min-width: 1440px) {
    padding: 0 32px;
  }

  /* XL - Widescreen */
  @media (min-width: 1920px) {
    padding: 0 80px;
  }
`;

